import React from 'react';
import { IntlShape, useIntl } from 'react-intl';
import { USD_CURRENCY } from '../../utils/Constants';

interface CurrencyDisplayProps {
  amount: number | undefined; // Amount to format
  currency: string; // Currency code, e.g., 'USD', 'EUR'
}

export const formatCurrency = (
  intl: IntlShape,
  amount: number,
  options?: {
    currency?: string,
    minimumFractionDigits?: number,
    maximumFractionDigits?: number,
  },
) => intl.formatNumber(amount, {
  style: 'currency',
  currency: USD_CURRENCY,
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
  ...options,
});

export const CurrencyDisplay: React.FC<CurrencyDisplayProps> = ({ amount, currency }) => {
  const intl = useIntl();
  const formattedCurrency = formatCurrency(intl, amount ?? 0, { currency });

  return (
    <p>{formattedCurrency}</p>
  );
};
